import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  signal,
} from '@angular/core';
import { PrevisionService } from '@core/services/prevision.service';
import { IPrevisiones } from '@models/IPrevisiones';
import { PrevisionesTableReadonlyComponent } from '@shared/previsiones-table-readonly/previsiones-table-readonly.component';

@Component({
  selector: 'app-ultimas-previsiones',
  imports: [PrevisionesTableReadonlyComponent],
  providers: [DatePipe],
  templateUrl: './ultimas-previsiones.component.html',
  styleUrl: './ultimas-previsiones.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UltimasPrevisionesComponent {
  ultimasPrevisiones = signal<IPrevisiones>([]);
  centroId = input<number>();

  constructor(private pervisionService: PrevisionService) {
    effect((onCleanup) => {
      const id = this.centroId();
      if (id == null) return;

      const dates = this.pervisionService.calculateWeekRange();
      const sub = this.pervisionService
        .getPrevisionByDates(dates.beginDate, dates.endDate, id)
        .subscribe({
          next: (res) => {
            this.ultimasPrevisiones.set(res);
          },
          error: () => this.ultimasPrevisiones.set([]),
        });

      onCleanup(() => sub.unsubscribe());
    });
  }
}
